import React, { useState } from 'react'
import cl from 'classnames'
import styles from './login-page.module.scss'
import { ColorPresetProp, StyleProps } from '@touche-lts/panel-ui/dist'

import { SectionContainer } from '@touche-lts/panel-ui/dist/components/shared/section-container'
import { H1 } from '@touche-lts/panel-ui/dist/components/shared/h1'
import { Button, ButtonProps } from '@touche-lts/panel-ui/dist/components/shared/button'
import { Checkbox } from '@touche-lts/panel-ui/dist/components/shared/checkbox'
import { HorizontalLine } from '@touche-lts/panel-ui/dist/components/shared/horizontal-line'
import { Input, InputProps } from '@touche-lts/panel-ui/dist/components/shared/input'
import { Text1 } from '@touche-lts/panel-ui/dist/components/shared/text1'
import { IconLogoLogin } from '@touche-lts/panel-ui/dist/components/icons/icon-logo-login'
import { IconFingerprintLogin } from '@touche-lts/panel-ui/dist/components/icons/icon-fingerprint-login'
import { IconLogoLoginDark } from '@touche-lts/panel-ui/dist/components/icons/icon-logo-login-dark'
import { Tab } from '@touche-lts/panel-ui/dist/components/shared/tab'
import { Tabs } from './login-page.utils'
import { RE_CAPTCHA_SITE_KEY } from 'config/environment'
import ReCAPTCHA from 'react-google-recaptcha';
import { ReactComponent as GoogleIcon } from 'assets/icons/svg/google.svg'
import { ReactComponent as MicrosoftIcon } from 'assets/icons/svg/microsoft.svg'
import { ReactComponent as AppleIcon } from 'assets/icons/svg/apple.svg'

export interface LoginPageProps extends StyleProps, ColorPresetProp {
  onFirstNameChange?: InputProps['onChange']
  onLastNameChange?: InputProps['onChange']
  firstNameValue?: InputProps['value']
  lastNameValue?: InputProps['value']
  onEmailAddressRegisterChange?: InputProps['onChange']
  emailAddressRegisterValue?: InputProps['value']
  onPasswordRegisterChange?: InputProps['onChange']
  passwordRegisterValue?: InputProps['value']
  emailAddressValue?: InputProps['value']
  onEmailAddressChange?: InputProps['onChange']
  passwordValue?: InputProps['value']
  onPasswordChange?: InputProps['onChange']
  loginButtonProps?: ButtonProps
  registerButtonProps?: ButtonProps
  headingText?: string
  onRememberChange?: (value: boolean) => void;
  onReCaptchaChange?: (value: string) => void;
  onGoogleLogin?: () => void;
  onMicrosoftLogin?: () => void;
  onAppleLogin?: () => void;
}

const LoginPageComponent = (props: LoginPageProps) => {
  const {
    className,
    style,
    colorPreset,
    emailAddressValue,
    onEmailAddressChange,
    passwordValue,
    onFirstNameChange,
    onLastNameChange,
    firstNameValue,
    lastNameValue,
    emailAddressRegisterValue,
    onEmailAddressRegisterChange,
    onPasswordRegisterChange,
    passwordRegisterValue,
    onPasswordChange,
    loginButtonProps,
    registerButtonProps,
    headingText = 'Log in / Register',
    onRememberChange,
    onReCaptchaChange,
    onGoogleLogin,
    onMicrosoftLogin,
    onAppleLogin
  } = props

  const tabs = colorPreset === 'dark' 

  const [actiaveTab, setActiveTab] = useState(Tabs.LOGIN);
  const [termsApplied, setTermsApplied] = useState(false);
  const [isRememberAcknowledge,setIsRememberAcknowledge] = useState(false);
  function handleRememberMe(){
    setIsRememberAcknowledge(!isRememberAcknowledge)
    onRememberChange(!isRememberAcknowledge)
  }

  return (
    <div
      className={cl(styles.container, styles[colorPreset], className)}
      style={style}
    >
      <div className={styles.formContainer}>
        <IconFingerprintLogin />
        <SectionContainer
          className={cl(styles.section, styles[colorPreset + 'Section'])}
          colorPreset={colorPreset}
          style={{backgroundColor :"#241f1f"}}
        >
          {colorPreset === 'dark' ? <IconLogoLoginDark /> : <IconLogoLogin />}
          <H1 className={cl(styles.title, styles[colorPreset + 'Title'])}>
            {headingText}
          </H1>

          {tabs ? (
            <div className={styles.tabsContainer}>
              <Tab
                colorPreset={colorPreset}
                label={Tabs.LOGIN}
                isSelected={actiaveTab === Tabs.LOGIN}
                onClick={() => setActiveTab(Tabs.LOGIN)}
              />
              <Tab
                colorPreset={colorPreset}
                label={Tabs.REGISTER}
                isSelected={actiaveTab === Tabs.REGISTER}
                onClick={() => setActiveTab(Tabs.REGISTER)}
              />
            </div>
          ) : (
            <HorizontalLine colorPreset={colorPreset} />
          )}
          {actiaveTab === Tabs.LOGIN && (
            <>
              <Input
                colorPreset={colorPreset}
                placeholder='Email'
                style={{ marginTop: 20 }}
                type='email'
                autoComplete='email'
                value={emailAddressValue}
                onChange={onEmailAddressChange}
              />
              <Input
                colorPreset={colorPreset}
                placeholder='Password'
                style={{ marginTop: 16 }}
                type='password'
                value={passwordValue}
                onChange={onPasswordChange}
              />
              <Button preset='icon' className={styles.rememberMeBttn} onClick={handleRememberMe}>
                <Checkbox isChecked={isRememberAcknowledge} />
                <Text1 colorPreset={colorPreset}>Remember me</Text1>
              </Button>

              <div className='my-3 me-auto'>
                <ReCAPTCHA
                  sitekey={RE_CAPTCHA_SITE_KEY}
                  onChange={onReCaptchaChange}
                  theme="dark"
                />
              </div>

              <Button
                preset='primary'
                {...loginButtonProps}
                className={cl(
                  styles.loginButton,
                  styles[colorPreset + 'LoginButton'],
                  loginButtonProps?.className
                )}
              />

              <div className={styles.dividerContainer}>
                <div className={styles.dividerLine} />
                <Text1 colorPreset={colorPreset} className={styles.dividerText}>Or continue with</Text1>
                <div className={styles.dividerLine} />
              </div>

              <div className={styles.socialButtonsContainer}>
                <Button
                  preset='secondary'
                  className={styles.socialButton}
                  onClick={onGoogleLogin}
                >
                  <GoogleIcon />
                  Login with Google
                </Button>
                <Button
                  preset='secondary'
                  className={styles.socialButton}
                  onClick={onMicrosoftLogin}
                >
                  <MicrosoftIcon />
                  Login with Microsoft
                </Button>
                {/* <Button
                  preset='secondary'
                  className={styles.socialButton}
                  onClick={onAppleLogin}
                >
                  <AppleIcon />
                  Apple
                </Button> */}
              </div>
            </>
          )}
          {actiaveTab === Tabs.REGISTER && (
            <>
              <Input
                colorPreset={colorPreset}
                placeholder='First name'
                style={{ marginTop: 20 }}
                type='text'
                autoComplete='email'
                value={firstNameValue}
                onChange={onFirstNameChange}
              />
              <Input
                colorPreset={colorPreset}
                placeholder='Last name'
                style={{ marginTop: 16 }}
                type='text'
                value={lastNameValue}
                onChange={onLastNameChange}
              />
              <Input
                colorPreset={colorPreset}
                placeholder='Email'
                style={{ marginTop: 20 }}
                type='email'
                autoComplete='email'
                value={emailAddressRegisterValue}
                onChange={onEmailAddressRegisterChange}
              />
              <Input
                colorPreset={colorPreset}
                placeholder='Password'
                style={{ marginTop: 16 }}
                type='password'
                value={passwordRegisterValue}
                onChange={onPasswordRegisterChange}
              />
              <Button preset='icon' className={styles.rememberMeBttn}>
                <Checkbox isChecked={termsApplied} onClick={() => setTermsApplied(!termsApplied)} />
                <Text1 colorPreset={colorPreset}>I agree to the &nbsp;<a href="/terms">Terms and Conditions</a></Text1>
              </Button>

              <Button
                preset='primary'
                {...registerButtonProps}
                className={cl(
                  styles.loginButton,
                  styles[colorPreset + 'LoginButton'],
                  loginButtonProps?.className
                )}
              />
            </>
          )}
        </SectionContainer>
      </div>
    </div>
  )
}

const LoginPage = LoginPageComponent
export { LoginPage }
